import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {UseLoader} from "../../../hooks/useLoader";
import {useForm} from "react-hook-form";
import {confirmDialog} from "primereact/confirmdialog";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {guardarCompensacion} from "../../../api/compensacion.service";

export const ModalNuevoCompensacion = ({show, hide}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const onSubmit = payload => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {
                    handleLoader(true);
                   const response = await guardarCompensacion(payload);
                    const data = await response.data;
                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});

                    hide()
                }
            });
        } catch (e) {
            handleLoader(false);
            console.log(e)
        }
    }


    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo item para compensación" visible={show} style={{width: '90vw'}}
                 onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información compensación
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descr"
                                    >
                                        Descripcion *
                                    </label>
                                    <textarea
                                        name="desc"
                                        {...register("descripcion", {required: true, maxLength: 100})}
                                        className="form-input-small"
                                        id="desc" rows="1">
                                </textarea>
                                    {errors.descripcion?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.descripcion?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 100 caracteres</span>}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-6/12">
                                    <label
                                        className="label-form"
                                        htmlFor="descA"
                                    >
                                        Descripcion abrev *
                                    </label>
                                    <input
                                        {...register("descA", {required: true, maxLength: 40 })}
                                        id="descA"
                                        type="text"
                                        className="form-input-small"
                                    />
                                    {errors.descA?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.descA?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 40 caracteres</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="orden"
                                    >
                                        Orden *
                                    </label>
                                    <input
                                        {...register("orden", {required: true, maxLength: 6, valueAsNumber: true })}
                                        id="orden"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {errors.orden?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.orden?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 6 caracteres</span>}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipocuen"
                                    >
                                        Tipo cuenta *
                                    </label>
                                    <select
                                        {...register("tipo_cuenta", {required: true })}
                                        className="form-input-small"
                                        id="tipocuen">
                                        <option value="">seleccione</option>
                                        <option value="P">Prestacional</option>
                                        <option value="C">Compensación</option>
                                    </select>
                                    {errors.tipoCuenta?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="porcentaje"
                                    >
                                        Porcentaje *
                                    </label>
                                    <input
                                        {...register("porcentaje", {required: true, maxLength: 11})}
                                        id="porcentaje"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {errors.porcentaje?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.porcentaje?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 11 caracteres</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="base_denomidor"
                                    >
                                        Base denominador *
                                    </label>
                                    <select
                                        {...register("base_denomidor", {required: true })}
                                        className="form-input-small"
                                        id="base_denomidor">
                                        <option value="">seleccione</option>
                                        <option value="P">Prestacional</option>
                                        <option value="C">Compensación</option>
                                    </select>
                                    {errors.base_denomidor?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cuenta_pasivo"
                                    >
                                        Cuenta pasivo *
                                    </label>
                                    <input
                                        {...register("cuenta_pasivo", {required: true, maxLength: 20})}
                                        id="cuenta_pasivo"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {errors.cuenta_pasivo?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.cuenta_pasivo?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 20 caracteres</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="cuenta_gasto"
                                    >
                                        Cuenta gasto *
                                    </label>
                                    <input
                                        {...register("cuenta_gasto", {required: true, maxLength: 20})}
                                        id="cuenta_gasto"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {errors.porcentaje?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.porcentaje?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 20 caracteres</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        {...register("estado", {required: true })}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {errors.estado?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>
                            </div>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>

        </>
    );
};

ModalNuevoCompensacion.propTypes = {
    show: PropTypes.bool,
    hide: PropTypes.func
};

ModalNuevoCompensacion.defaultProps = {
    show: false,
}

